module.exports = __webpack_public_path__ + "static/media/home-new.03592443.svg";